import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session/session.service';

@Component({
  selector: 'vit-rolling-numbers',
  templateUrl: 'rolling-numbers.component.html',
  styleUrls: ['rolling-numbers.component.scss']
})
export class RollingNumbersComponent {

  get numbersLane1(): number[] {
    return this.sessionService.numbers.filter((number: number, idx: number) => idx % 2 === 0);
  }

  get numbersLane2(): number[] {
    return this.sessionService.numbers.filter((number: number, idx: number) => idx % 2 === 1);
  }

  constructor(public sessionService: SessionService) {
  }

}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/game-view/rolling-numbers/rolling-numbers.component.ts